import React from 'react';
import { T } from 'shared/helper/translate';
var PlanStatusBadge = function PlanStatusBadge(_ref) {
  var status = _ref.status;
  var badgeLabel = function badgeLabel() {
    if (status === 'cancelled') return 'Active';
    if (status === 'payment-failed') return 'Payment Failed';
    return status;
  };
  return /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement("span", {
    className: "badge badge-rubriq-".concat(status, " text-capitalize")
  }, /*#__PURE__*/React.createElement(T, {
    source: badgeLabel()
  })));
};
export default PlanStatusBadge;